import { ImageUpload, Loader } from 'components';
import { SettingsUI } from 'features';
import { useFetchUser, useFetchCountries, useUpdateUser, useUpdateCompanyInfo } from 'hooks';
import { useEffect, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'state/hooks';
import { ChangePassword } from './change-password';
import { UpdateUserPayload, CompanyInfoPayload } from 'hooks';

/**
 * Interface for update user request data
 */
export interface UpdateUserRequestData {
  username?: string;
  email?: string;
  phone_number?: string;
  first_name?: string;
  last_name?: string;
  country_code?: string;
  date_of_birth?: string;
  display_photo?: string;
  address?: string;
  referral?: string;
  role?: string;
  country?: string;
}

/**
 * Interface for update company request data
 */
export interface UpdateCompanyRequestData {
  name?: string;
  industry?: string;
  hiring_frequency?: string;
  no_of_employees?: string;
  company_logo?: string;
}

const Settings = () => {
  // States
  const [image, setImage] = useState({ show: false, type: 'avatar' });
  const [password, setPassword] = useState(false);

  // Hooks
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const {
    firstName,
    lastName,
    email,
    role,
    phone,
    company,
    industry,
    hiringFrequency,
    noOfEmployees,
    avatar,
    companyLogo,
    country,
  } = user;
  const { getUser } = useFetchUser();
  const { mutate: updateUser } = useUpdateUser(dispatch, getUser, setImage, user);
  const { mutate: updateCompany } = useUpdateCompanyInfo(getUser, setImage);
  const {
    fetchCountries,
    countries,
    loading: loadingCountries,
  } = useFetchCountries();

  useEffect(() => {
    fetchCountries();
  }, []);

  const handleUpdateUser = (data: UpdateUserRequestData) => {
    updateUser(data);
  };

  const handleUpdateCompany = (data: UpdateCompanyRequestData) => {
    updateCompany(data);
  };

  const handleImageUpload = (data: string) => {
    if (image.type === 'avatar') {
      updateUser({ display_photo: data } as UpdateUserPayload);
    } else {
      updateCompany({ company_logo: data } as CompanyInfoPayload);
    }
  };

  const showLoader = loadingCountries;

  return (
    <div className="px-6 py-4 overflow-auto h-[calc(100vh-76px-var(--credit-banner-h,0px))]">
      <Loader loading={showLoader} />
      <ImageUpload
        {...image}
        close={() => setImage({ show: false, type: '' })}
        submit={handleImageUpload}
      />
      <ChangePassword show={password} close={() => setPassword(false)} />
      <SettingsUI
        submitPersonal={handleUpdateUser}
        submitBusiness={handleUpdateCompany}
        personalData={{
          firstName,
          lastName,
          email,
          role,
          number: {
            code: phone.code,
            value: `${phone.code}${phone.number}`,
            number: phone.number,
          },
          country: { label: country, value: country },
        }}
        companyData={{
          name: company,
          industry: industry,
          frequency: { label: hiringFrequency, value: hiringFrequency },
          employees: { label: noOfEmployees, value: noOfEmployees },
        }}
        logo={companyLogo}
        avatar={avatar}
        handleImageUpload={(type) => setImage({ show: true, type })}
        handleChangePassword={() => setPassword(true)}
        countryOptions={countries}
      />
    </div>
  );
};

export { Settings };